/**
 * @param {number} basePrice - Product/Service ki actual price
 * @param {object} selectedCurrency - Redux se aayi hui current currency
 */
// export const formatCurrency = (basePrice, selectedCurrency) => {
//     if (!basePrice || !selectedCurrency) return `₹ ${basePrice || 0}`;

//     // Calculation: Base Price * Exchange Rate
//     // (Dhyan dein: Agar API rate 1 INR = 0.012 USD de rahi hai toh multiply hoga)
//     const convertedPrice = parseFloat(basePrice) * parseFloat(selectedCurrency.exchange_rate || 1);
    
//     const formatter = new Intl.NumberFormat('en-US', {
//         minimumFractionDigits: selectedCurrency.decimal_places || 2,
//         maximumFractionDigits: selectedCurrency.decimal_places || 2,
//     });

//     return `${selectedCurrency.symbol || '₹'} ${formatter.format(convertedPrice)}`;
// };
// src/utils/currencyHelper.js

export const formatCurrency = (basePrice, selectedCurrency) => {
    // Sirf tab ₹ dikhao jab selectedCurrency ka data hi na ho
    if (!selectedCurrency) {
        return `₹ ${basePrice || 0}`;
    }

    // Agar price null ya undefined hai toh 0 maan lo
    const price = parseFloat(basePrice) || 0; 
    const rate = parseFloat(selectedCurrency.exchange_rate) || 1;
    const symbol = selectedCurrency.symbol || '₹';
    const decimals = selectedCurrency.decimal_places || 2;

    const convertedPrice = price * rate;
    
    const formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    });

    return `${symbol} ${formatter.format(convertedPrice)}`;
};